module.exports = __webpack_public_path__ + "static/media/healthcare_doc_slider_phone3.3f6a986a.png";